import type { QueryFilter } from '@domain/schemas/filters.schema';

import type { FilterRow } from '../types';

import { isExistenceComparator } from './comparator-utils';

export const isRowComplete = (row: FilterRow): boolean =>
  row.field !== '' && row.comparator !== '' && (row.values.length > 0 || isExistenceComparator(row.comparator));

export const deriveQueryFilters = (rows: FilterRow[]): QueryFilter[] =>
  rows
    .filter(isRowComplete)
    .map(({ field, comparator, values }) => ({ field, comparator: comparator as QueryFilter['comparator'], values }));

export const deriveActiveCount = (rows: FilterRow[]): number => rows.filter(isRowComplete).length;
